import script from "./YesNoAnswer.vue?vue&type=script&setup=true&lang=ts"
export * from "./YesNoAnswer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__